import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {PcCallComponent} from "../component/protected-components/pc-call/pc-call.component";
import {PcCallActiveComponent} from "../component/protected-components/pc-call-active/pc-call-active.component";
import {PcCallDialComponent} from "../component/protected-components/pc-call-dial/pc-call-dial.component";
import {
    PcCallIncomingAtObjectComponent
} from "../component/protected-components/pc-call-incoming-at-object/pc-call-incoming-at-object.component";
import {
    PcHeaderCallActiveComponent
} from "../component/protected-components/pc-header-call-active/pc-header-call-active.component";
import {PcObjectCallsComponent} from "../component/protected-components/pc-object-calls/pc-object-calls.component";
import {
    PcCallWfProcessStepActivitySideComponent
} from "../component/protected-components/wf/pc-call-wf-process-step-activity-side/pc-call-wf-process-step-activity-side.component";
import {PcConfigPage} from "../page/overview/pc-config/pc-config.page";
import {PcIncomingCallPage} from "../page/overview/pc-me/pc-incoming-call/pc-incoming-call.page";
import {PcMyCallsPage} from "../page/overview/pc-me/pc-my-calls/pc-my-calls.page";
import {PcQmCallControlPage} from "../page/overview/pc-qm/pc-qm-call-control/pc-qm-call-control.page";
import {PcQmCallsPage} from "../page/overview/pc-qm/pc-qm-calls/pc-qm-calls.page";
import {PcQmDashboardPage} from "../page/overview/pc-qm/pc-qm-dashboard/pc-qm-dashboard.page";
import {PcMyTeamCallsPage} from "../page/overview/pc-team/pc-my-team-calls/pc-my-team-calls.page";
import {PcTeamDashboardPage} from "../page/overview/pc-team/pc-team-dashboard/pc-team-dashboard.page";
import {PcKpiComponent} from "../page/pc-overview-page/components/kpiComponent/pc-kpi.component";
import {PcStatisticsComponent} from "../page/pc-overview-page/components/statisticsComponent/pc-statistics.component";
import {
    PcCallDialConsultantComponent
} from "../component/protected-components/consultant-component/pc-call-dial/pc-call-dial-consultant.component";

const pcModuleEntry : TestModuleDefinition = {
    key: 'pc',
    label: 'Call (pc)',
    components: [
        {
            key: 'PcCallComponent',
            component: PcCallComponent,
            selector: 'mvs-pc-call',
            type: 'ObjectBaseComponent',
            label: 'PC call',
        },
        {
            key: 'PcCallActiveComponent',
            component: PcCallActiveComponent,
            selector: 'mvs-pc-call-active',
            type: 'Component',
            label: 'PC call Active',
        },
        {
            key: 'PcCallDialComponent',
            component: PcCallDialComponent,
            selector: 'mvs-pc-call-dial',
            type: 'Component',
            label: 'PC call Dial',
        },
        {
            key: 'PcCallIncomingAtObjectComponent',
            component: PcCallIncomingAtObjectComponent,
            selector: 'mvs-pc-call-incoming-at-object',
            type: 'Component',
            label: 'PC call incoming ',
        },
        {
            key: 'PcHeaderCallActiveComponent',
            component: PcHeaderCallActiveComponent,
            selector: 'mvs-pc-header-call-active',
            type: 'Component',
            label: 'PC header call Active',
        },
        {
            key: 'PcObjectCallsComponent',
            component: PcObjectCallsComponent,
            selector: 'mvs-pc-object-calls',
            type: 'Component',
            label: 'PC object calls',
        },
        {
            key: 'PcCallWfProcessStepActivitySideComponent',
            component: PcCallWfProcessStepActivitySideComponent,
            selector: 'mvs-wf-process-step-activity-object-call',
            type: 'Component',
            label: 'PC WorkFlow'
        },
        {
            key: 'PcConfigPage',
            component: PcConfigPage,
            selector: 'mvs-pc-config-page',
            type: 'PageComponent',
            label: 'PC Config Page',
        },
        {
            key: 'PcIncomingCallPage',
            component: PcIncomingCallPage,
            selector: 'mvs-pc-incoming-call-page',
            type: 'PageComponent',
            label: 'PC Incoming Call Page',
        },
        {
            key: 'PcMyCallsPage',
            component: PcMyCallsPage,
            selector: 'mvs-pc-my-calls',
            type: 'PageComponent',
            label: 'PC MyCalls Page',
        },
        {
            key: 'PcQmCallControlPage',
            component: PcQmCallControlPage,
            selector: 'mvs-call-control',
            type: 'PageComponent',
            label: 'PC Call Control Page',
        },
        {
            key: 'PcQmCallsPage',
            component: PcQmCallsPage,
            selector: 'mvs-pc-qm-calls-page',
            type: 'PageComponent',
            label: 'PC QM Call Page',
        },
        {
            key: 'PcQmDashboardPage' ,
            component: PcQmDashboardPage,
            selector: 'pc-qm-dashboard',
            type: 'MvsDashboardPage',
            label: 'PC QM Dashboard',
        },
        {
            key: 'PcMyTeamCallsPage',
            component: PcMyTeamCallsPage,
            selector: 'mvs-pc-my-team-calls-page',
            type: 'PageComponent',
            label: 'PC MyTeam Calls',
        },
        {
            key: 'PcTeamDashboardPage',
            component: PcTeamDashboardPage,
            selector: 'pc-team-dashboard',
            type: 'MvsDashboardPage',
            label: 'PC Dashboard',
        },
        {
            key: 'PcKpiComponent',
            component: PcKpiComponent,
            selector: 'pc-kpi',
            type: 'Component',
            label: 'PC Kpi',
        },
        {
            key: 'PcStatisticsComponent',
            component: PcStatisticsComponent,
            selector: 'pc-statistics',
            type: 'Component',
            label: 'PC Statistics',
        },
        {
            key: 'PcCallDialConsultantComponent',
            component: PcCallDialConsultantComponent,
            selector: 'mvs-pc-call-dial-consultant',
            type: 'PcCallDialComponent',
            label: 'pc call dial consultant component'
        },
        {
            key: 'PcCallDialConsultantComponent',
            component: PcCallDialConsultantComponent,
            selector: 'mvs-pc-call-dial-consultant',
            type: 'PcCallDialComponent',
            label: 'pc call dial consultant component'
        },
    ]
}

export const PC_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: pcModuleEntry, multi: true },
];